
import { curry3, uncurry2, createObj, equals, comparePrimitives, Exception, createAtom } from "./fable_modules/fable-library-js.5.0.0/Util.js";
import { append as append_1, map as map_1, singleton, ofArray, cons, empty } from "./fable_modules/fable-library-js.5.0.0/List.js";
import { utcNow, toString } from "./fable_modules/fable-library-js.5.0.0/Date.js";
import { unwrap, value as value_65, bind, defaultArgWith, map, defaultArg, ofNullable, some } from "./fable_modules/fable-library-js.5.0.0/Option.js";
import { printf, toText } from "./fable_modules/fable-library-js.5.0.0/String.js";
import { Convert_fromJson, Convert_serialize } from "./fable_modules/Fable.SimpleJson.3.24.0/Json.Converter.fs.js";
import { createTypeInfo } from "./fable_modules/Fable.SimpleJson.3.24.0/TypeInfo.Converter.fs.js";
import { Router_goToUrl, PageModule_toUrlSegments, Router_setUrlToPage, PageModule_themeSwitcherVisible, PageModule_menuVisible, Router_navigatePage, Cmd_navigatePage, Page, PageModule_parseFromUrlSegments, PageModule_isLoginPage, Router_pageTitle, PageModule_defaultPage, Page_$reflection } from "./Router.js";
import { SimpleJson_tryParse } from "./fable_modules/Fable.SimpleJson.3.24.0/SimpleJson.fs.js";
import { newGuid, tryParse } from "./fable_modules/fable-library-js.5.0.0/Guid.js";
import { Record, Union, FSharpRef } from "./fable_modules/fable-library-js.5.0.0/Types.js";
import { record_type, class_type, union_type, lambda_type, bool_type } from "./fable_modules/fable-library-js.5.0.0/Reflection.js";
import { Response_UserProfile_$reflection } from "./StenaWeather.WeatherServiceUI.Shared/Profiles/API.js";
import { ServerError_$reflection } from "./StenaWeather.WeatherServiceUI.Shared/Errors.js";
import { Result_Map, FSharpResult$2 } from "./fable_modules/fable-library-js.5.0.0/Result.js";
import { ThemeStorage_switchTheme, Color, theme as theme_1, Theme, ThemeStorage_getTheme, ThemeStorage_setTheme } from "./Theme.js";
import { RouterModule_router, RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_encodeParts, RouterModule_urlSegments } from "./lib/Feliz.Router/Router.js";
import { Cmd_OfPromise_either, Cmd_ofEffect, Cmd_none, Cmd_batch, Cmd_OfPromise_perform } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { onProfilesAPI, onAnalyticsAPI, onPortWindAPI, Cmd_OfAsync_eitherAsResult, Auth_userManager } from "./Server.js";
import { noCmd, withCmd } from "./UseElmish.js";
import { AsyncHelpers_start } from "./fable_modules/Fable.Elmish.5.0.2/prelude.fs.js";
import { ofList } from "./fable_modules/fable-library-js.5.0.0/Map.js";
import { IconModule_View } from "./Components/StenaWebUI/Icons/Icon.js";
import { Fragment, useState, createElement } from "react";
import React from "react";
import * as react from "react";
import { BoxModule_View } from "./Components/StenaWebUI/Core/Box.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.5.0.0/Seq.js";
import { SidebarMenuCollapsible_View, SidebarMenuHeading_View, SidebarMenuLink_View } from "./Components/StenaWebUI/Panels/SidebarMenu.js";
import { HtmlHelper_createElement } from "./fable_modules/Feliz.3.3.3/Html.fs.js";
import { ToastPosition } from "./Components/HotToast/HotToast.js";
import { fromSeconds } from "./fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { ToasterModule_View } from "./Components/HotToast/Toaster.js";
import { CurrentSettingsDisplay } from "./Components/TimeZones/Components.js";
import { faCloudRain, faTemperatureHigh, faCloud, faMoon, faWater, faWind, faAnchor, faChartPie, faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { sws_white_vertical } from "./images/sws_white_vertical.svg.js";
import { DateTimeRange } from "./StenaWeather.Domain/PortWind.js";
import { WeatherTypeModule_Parameter } from "./StenaWeather.Domain/Weather.js";
import { faCustomCurrentIcon } from "../src/StenaWeather.WeatherServiceUI.Client/Components/StenaWebUI/Icons/CurrentIcon.js";
import { SidebarMenu } from "@stenajs-webui/panels";
import { SvgHelper_createSvgElement } from "./fable_modules/Feliz.3.3.3/Svg.fs.js";
import { svg_height, svg_width } from "./Feliz.js";
import { saveToStorage, getDefaultUserSettings, tryGetFromStorage } from "./Components/TimeZones/Storage.js";
import { TimeZoneContext, TimezoneContext } from "./Components/TimeZones/Context.js";
import { defaultOf } from "./fable_modules/fable-library-js.5.0.0/Util.js";
import { defaultOf as defaultOf_1 } from "./fable_modules/fable-library-js.5.0.0/Util.js";
import { defaultOf as defaultOf_2 } from "./fable_modules/fable-library-js.5.0.0/Util.js";
import { start } from "./fable_modules/fable-library-js.5.0.0/Async.js";
import { defaultOf as defaultOf_3 } from "./fable_modules/fable-library-js.5.0.0/Util.js";
import { ModelsView } from "./Pages/Models.js";
import { VesselsView } from "./Pages/Vessels.js";
import { SessionDetailsView } from "./Pages/SessionDetails.js";
import { SessionReportView } from "./Pages/SessionReport.js";
import { DashboardView } from "./Pages/Dashboard.js";
import { PortWindStatusView } from "./Pages/Portwind/PortWindStatus.js";
import { PortWindOutageReportView } from "./Pages/Portwind/PortWindOutageReport.js";
import { PortWindDashboardView } from "./Pages/Portwind/PortWindDashboard.js";
import { ViewConfigModule_Report, ViewConfigModule_Simple, State as State_1, ViewConfigModule_Default } from "./Pages/Portwind/PortWindCommon.js";
import { LoadingScreenModule_View } from "./Components/StenaWebUI/Panels/LoadingScreen.js";
import { Interop_setKeyOnObj } from "./fable_modules/Feliz.3.3.3/Helper/Helpers.fs.js";

export const Const_menuToggleOpenSize = 28;

export let msgHistoryLog = createAtom(empty());

export function logMsgState(msg, state) {
    const s = `${toString(utcNow(), "yyyy-MM-dd HH:mm:ss")} ${msg} -> ${state}`;
    console.log(some(s));
    msgHistoryLog(cons(s, msgHistoryLog()));
}

export function SessionStorage_setItem(key, value) {
    window.sessionStorage.setItem(key, value);
    console.log(some(toText(printf("Set item: %s -> %s"))(key)(value)));
}

export function SessionStorage_getItem(key) {
    const x = ofNullable(window.sessionStorage.getItem(key));
    console.log(some(toText(printf("Get item: %s -> %A"))(key)(x)));
    return x;
}

export function SessionStorage_setLoginReturnPage(page) {
    SessionStorage_setItem("loginReturnPage", Convert_serialize(page, createTypeInfo(Page_$reflection())));
}

export function SessionStorage_getLoginReturnPage() {
    return defaultArg(map((input) => {
        const matchValue = SimpleJson_tryParse(input);
        if (matchValue != null) {
            return Convert_fromJson(matchValue, createTypeInfo(Page_$reflection()));
        }
        else {
            throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
        }
    }, SessionStorage_getItem("loginReturnPage")), PageModule_defaultPage);
}

export function SessionStorage_tryParseGuid(s) {
    let matchValue;
    let outArg = "00000000-0000-0000-0000-000000000000";
    matchValue = [tryParse(s, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return undefined;
    }
}

export function SessionStorage_getOrCreateClientId() {
    return defaultArgWith(bind(SessionStorage_tryParseGuid, SessionStorage_getItem("weatherservice.sessionclientid")), () => {
        const g = newGuid();
        SessionStorage_setItem("weatherservice.sessionclientid", g);
        return g;
    });
}

export class LoginStep extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InitAuthentication", "Authenticate", "LoadProfile", "AuthorizedLimitedAccess", "ProfileLoaded"];
    }
}

export function LoginStep_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.View.LoginStep", [], LoginStep, () => [[], [], [], [["Item", lambda_type(Page_$reflection(), bool_type)]], [["Item", Response_UserProfile_$reflection()]]]);
}

export class AuthState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InProgress", "Unauthorized", "LimitedAccess", "LoggedIn"];
    }
}

export function AuthState_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.View.AuthState", [], AuthState, () => [[], [], [["Item", lambda_type(Page_$reflection(), bool_type)]], [["Item", Response_UserProfile_$reflection()]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UrlChanged", "NextLoginStep", "ToggleMenu"];
    }
}

export function Msg_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.View.Msg", [], Msg, () => [[["Item", Page_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [LoginStep_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", LoginStep_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]], []]);
}

export class State extends Record {
    constructor(Page, Auth, ShowMenu, ClientSessionId) {
        super();
        this.Page = Page;
        this.Auth = Auth;
        this.ShowMenu = ShowMenu;
        this.ClientSessionId = ClientSessionId;
    }
}

export function State_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.View.State", [], State, () => [["Page", Page_$reflection()], ["Auth", AuthState_$reflection()], ["ShowMenu", bool_type], ["ClientSessionId", class_type("System.Guid")]]);
}

export function changePage(page, state) {
    let matchValue;
    console.log(some(toText(printf("Change page: %A"))(page)));
    document.title = Router_pageTitle(page);
    if (!PageModule_isLoginPage(state.Page)) {
        SessionStorage_setLoginReturnPage(page);
    }
    logMsgState(toText(printf("Change page: %A"))(page), state);
    ThemeStorage_setTheme((matchValue = ThemeStorage_getTheme(), (page.tag === 6) ? (new Theme(2, [])) : ((matchValue.tag === 2) ? (new Theme(0, [])) : matchValue)));
    return new State(page, state.Auth, state.ShowMenu, state.ClientSessionId);
}

export function init() {
    const clientSessionId = SessionStorage_getOrCreateClientId();
    const isPageWithIpAccess = (_arg) => {
        switch (_arg.tag) {
            case 5:
                return true;
            case 6:
                return true;
            case 7:
                return true;
            case 8:
                return true;
            case 9:
                return true;
            default:
                return false;
        }
    };
    const nextPage = PageModule_parseFromUrlSegments(RouterModule_urlSegments(window.location.pathname + window.location.search, 2));
    let cmd_1;
    switch (nextPage.tag) {
        case 12: {
            cmd_1 = Cmd_OfPromise_perform(() => Auth_userManager.signinRedirectCallback(), undefined, (_arg_2) => (new Msg(1, [new FSharpResult$2(0, [new LoginStep(2, [])])])));
            break;
        }
        case 13: {
            cmd_1 = Cmd_OfPromise_perform(() => Auth_userManager.signinSilentCallback(), undefined, (_arg_3) => (new Msg(1, [new FSharpResult$2(0, [new LoginStep(2, [])])])));
            break;
        }
        case 10: {
            cmd_1 = Cmd_OfPromise_perform(() => Auth_userManager.signinRedirect(), undefined, () => (new Msg(0, [new Page(10, [])])));
            break;
        }
        default:
            if (isPageWithIpAccess(nextPage)) {
                const cmd = Cmd_OfAsync_eitherAsResult(() => onPortWindAPI(clientSessionId, (x) => x.CheckAuthByIP()), (arg) => (new Msg(1, [Result_Map(() => (new LoginStep(3, [isPageWithIpAccess])), arg)])));
                cmd_1 = Cmd_batch(ofArray([Cmd_navigatePage(nextPage), cmd]));
            }
            else {
                cmd_1 = Cmd_batch(ofArray([Cmd_navigatePage(nextPage), singleton((dispatch) => {
                    dispatch(new Msg(1, [new FSharpResult$2(0, [new LoginStep(0, [])])]));
                })]));
            }
    }
    return [changePage(nextPage, new State(nextPage, new AuthState(0, []), false, clientSessionId)), cmd_1];
}

export function update(msg, state) {
    let x_2;
    const matchValue = state.Auth;
    let matchResult, page_3, pageCheck_3, page_4, page_5, e, step;
    switch (msg.tag) {
        case 1: {
            if (msg.fields[0].tag === 0) {
                matchResult = 7;
                step = msg.fields[0].fields[0];
            }
            else {
                matchResult = 6;
                e = msg.fields[0].fields[0];
            }
            break;
        }
        case 2: {
            matchResult = 8;
            break;
        }
        default:
            switch (msg.fields[0].tag) {
                case 13:
                case 12: {
                    matchResult = 0;
                    break;
                }
                case 11: {
                    if (matchValue.tag === 2) {
                        if (matchValue.fields[0](msg.fields[0])) {
                            matchResult = 1;
                            page_3 = msg.fields[0];
                            pageCheck_3 = matchValue.fields[0];
                        }
                        else {
                            matchResult = 2;
                            page_4 = msg.fields[0];
                        }
                    }
                    else {
                        matchResult = 3;
                    }
                    break;
                }
                case 10: {
                    if (matchValue.tag === 2) {
                        if (matchValue.fields[0](msg.fields[0])) {
                            matchResult = 1;
                            page_3 = msg.fields[0];
                            pageCheck_3 = matchValue.fields[0];
                        }
                        else {
                            matchResult = 2;
                            page_4 = msg.fields[0];
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                    break;
                }
                default:
                    if (matchValue.tag === 2) {
                        if (matchValue.fields[0](msg.fields[0])) {
                            matchResult = 1;
                            page_3 = msg.fields[0];
                            pageCheck_3 = matchValue.fields[0];
                        }
                        else {
                            matchResult = 2;
                            page_4 = msg.fields[0];
                        }
                    }
                    else {
                        matchResult = 5;
                        page_5 = msg.fields[0];
                    }
            }
    }
    switch (matchResult) {
        case 0: {
            x_2 = [state, Cmd_none()];
            break;
        }
        case 1: {
            x_2 = [changePage(page_3, state), Cmd_none()];
            break;
        }
        case 2: {
            const v = changePage(page_4, new State(state.Page, new AuthState(0, []), state.ShowMenu, state.ClientSessionId));
            x_2 = withCmd(Cmd_OfPromise_perform(() => Auth_userManager.signinRedirect(), undefined, () => (new Msg(0, [SessionStorage_getLoginReturnPage()]))), v);
            break;
        }
        case 3: {
            const v_1 = new State(state.Page, new AuthState(0, []), state.ShowMenu, state.ClientSessionId);
            x_2 = withCmd(Cmd_OfPromise_perform(() => Auth_userManager.signinRedirect(), undefined, () => (new Msg(0, [SessionStorage_getLoginReturnPage()]))), v_1);
            break;
        }
        case 4: {
            const v_2 = new State(state.Page, new AuthState(0, []), state.ShowMenu, state.ClientSessionId);
            x_2 = withCmd(Cmd_OfPromise_perform(() => Auth_userManager.signoutRedirect(), undefined, () => (new Msg(0, [PageModule_defaultPage]))), v_2);
            break;
        }
        case 5: {
            x_2 = [changePage(page_5, state), Cmd_none()];
            break;
        }
        case 6: {
            if (e.tag === 3) {
                AsyncHelpers_start(onAnalyticsAPI(state.ClientSessionId, (x) => x.LogWarning(window.location.href, state.ClientSessionId, `Authorization failed: ${msgHistoryLog()}`)));
                x_2 = noCmd(new State(state.Page, new AuthState(1, []), state.ShowMenu, state.ClientSessionId));
            }
            else {
                const v_4 = new State(state.Page, new AuthState(0, []), state.ShowMenu, state.ClientSessionId);
                x_2 = withCmd(Cmd_navigatePage(new Page(11, [])), v_4);
            }
            break;
        }
        case 7: {
            switch (step.tag) {
                case 1: {
                    x_2 = withCmd(Cmd_ofEffect((_arg_5) => {
                        Auth_userManager.signinRedirect();
                    }), state);
                    break;
                }
                case 2: {
                    x_2 = withCmd(Cmd_OfAsync_eitherAsResult(() => onProfilesAPI((x_1) => x_1.GetProfile()), (arg_1) => (new Msg(1, [Result_Map((Item_2) => (new LoginStep(4, [Item_2])), arg_1)]))), state);
                    break;
                }
                case 3: {
                    x_2 = noCmd(new State(state.Page, new AuthState(2, [step.fields[0]]), state.ShowMenu, state.ClientSessionId));
                    break;
                }
                case 4: {
                    const state_1 = new State(state.Page, new AuthState(3, [step.fields[0]]), state.ShowMenu, state.ClientSessionId);
                    if (state_1.Page.tag === 12) {
                        const page_6 = SessionStorage_getLoginReturnPage();
                        const v_9 = new State(page_6, state_1.Auth, state_1.ShowMenu, state_1.ClientSessionId);
                        x_2 = withCmd(Cmd_navigatePage(page_6), v_9);
                    }
                    else {
                        x_2 = noCmd(state_1);
                    }
                    break;
                }
                default: {
                    const onError = (_arg_3) => (new Msg(1, [new FSharpResult$2(0, [new LoginStep(1, [])])]));
                    x_2 = withCmd(Cmd_OfPromise_either(() => Auth_userManager.getUser(), undefined, (arg) => defaultArgWith(map((_arg_4) => (new Msg(1, [new FSharpResult$2(0, [new LoginStep(2, [])])])), arg), onError), onError), state);
                }
            }
            break;
        }
        default:
            x_2 = [new State(state.Page, state.Auth, !state.ShowMenu, state.ClientSessionId), Cmd_none()];
    }
    logMsgState(msg, state);
    return x_2;
}

function inLayout(dispatch, showMenu, currentPage, content) {
    const link = (lbl, ic, nextPage) => {
        const iconObj = map((i) => {
            const p_1_2 = ofList(map_1((value_1) => value_1, singleton(["children", singleton(IconModule_View(ofList(map_1((value) => value, ofArray([["size", 13], ["icon", i], ["color", theme_1(new Color(1, []))]])), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            })))])), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            });
            return createElement(BoxModule_View, {
                p: p_1_2,
            });
        }, ic);
        const isSelected = (currentPage.tag === 2) ? ((nextPage.tag === 1) ? true : equals(currentPage, nextPage)) : ((currentPage.tag === 5) ? ((nextPage.tag === 5) ? true : equals(currentPage, nextPage)) : ((currentPage.tag === 9) ? ((nextPage.tag === 9) ? true : equals(currentPage, nextPage)) : equals(currentPage, nextPage)));
        const p_1_3 = ofList(map_1((value_2) => value_2, toList(delay(() => append(singleton_1(["onClick", () => {
            Router_navigatePage(nextPage);
        }]), delay(() => append(singleton_1(["id", `menu${lbl}`]), delay(() => append(singleton_1(["label", lbl]), delay(() => append(isSelected ? singleton_1(["selected", true]) : empty_1(), delay(() => ((iconObj != null) ? singleton_1(["left", value_65(iconObj)]) : singleton_1(["indent", true]))))))))))))), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        });
        return createElement(SidebarMenuLink_View, {
            p: p_1_3,
        });
    };
    return HtmlHelper_createElement("div", ofArray([["className", "layout"], ["children", toList(delay(() => {
        let p_1_4;
        return append(singleton_1((p_1_4 = ofList(map_1((value_6) => value_6, ofArray([["position", new ToastPosition(2, [])], ["toastOptions", singleton(["duration", ~~fromSeconds(4)])]])), {
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        }), createElement(ToasterModule_View, {
            p: p_1_4,
        }))), delay(() => {
            let p_1_5, children, p_1_7, p_1_8, p_1_9, p_1_10, p_1_11, p_1_12, props_12;
            const timezone = HtmlHelper_createElement("div", ofArray([["className", "timezone-display-containter"], ["children", singleton((p_1_5 = ofList(map_1((value_11) => value_11, ofArray([["spacing", 2], ["indent", 4], ["background", theme_1(new Color(5, []))], ["children", singleton(createElement(CurrentSettingsDisplay, null))]])), {
                Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
            }), createElement(BoxModule_View, {
                p: p_1_5,
            })))]]));
            let toggleMenu;
            const toggleIcon = showMenu ? faXmark : faBars;
            toggleMenu = HtmlHelper_createElement("div", ofArray([["className", showMenu ? "menu-toggle-close" : "menu-toggle-open"], ["children", [HtmlHelper_createElement("span", ofArray([["onClick", (_arg_1) => {
                dispatch(new Msg(2, []));
            }], ["style", {
                cursor: "pointer",
            }], ["children", [IconModule_View(ofList(map_1((value_18) => value_18, ofArray([["icon", toggleIcon], ["size", Const_menuToggleOpenSize], ["color", theme_1(new Color(5, []))]])), {
                Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
            }))]]]))]]]));
            return append((PageModule_menuVisible(currentPage) && showMenu) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", "menu"], ["children", [HtmlHelper_createElement("div", ofArray([["className", "menu-content"], ["children", [toggleMenu, (children = [HtmlHelper_createElement("div", ofArray([["className", "menu-logo"], ["children", singleton(sws_white_vertical)]])), (p_1_7 = ofList(map_1((value_30) => value_30, singleton(["label", "APPLICATIONS"])), {
                Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
            }), createElement(SidebarMenuHeading_View, {
                p: p_1_7,
            })), (p_1_8 = ofList(map_1((value_31) => value_31, ofArray([["label", "Dashboard"], ["leftIcon", faChartPie], ["children", ofArray([link("WeatherService Status", undefined, new Page(4, [])), link("PortWind Status", undefined, new Page(8, [])), link("PortWind Outage Report", undefined, new Page(9, [undefined]))])]])), {
                Compare: (x_7, y_7) => (comparePrimitives(x_7, y_7) | 0),
            }), createElement(SidebarMenuCollapsible_View, {
                p: p_1_8,
            })), link("Vessels", faAnchor, new Page(1, [])), (p_1_9 = ofList(map_1((value_32) => value_32, ofArray([["label", "PortWind"], ["leftIcon", faWind], ["children", ofArray([link("Wind Sensor", undefined, new Page(5, [undefined])), link("Historic Data", undefined, new Page(7, [undefined, new DateTimeRange(undefined, undefined)]))])]])), {
                Compare: (x_8, y_8) => (comparePrimitives(x_8, y_8) | 0),
            }), createElement(SidebarMenuCollapsible_View, {
                p: p_1_9,
            })), (p_1_10 = ofList(map_1((value_33) => value_33, singleton(["label", "FORECAST MODELS"])), {
                Compare: (x_9, y_9) => (comparePrimitives(x_9, y_9) | 0),
            }), createElement(SidebarMenuHeading_View, {
                p: p_1_10,
            })), (p_1_11 = ofList(map_1((value_34) => value_34, ofArray([["label", "Wind"], ["leftIcon", faWind], ["children", ofArray([link("Wind 10m", undefined, new Page(0, [new WeatherTypeModule_Parameter(0, [])])), link("Wind 50m", undefined, new Page(0, [new WeatherTypeModule_Parameter(1, [])]))])]])), {
                Compare: (x_10, y_10) => (comparePrimitives(x_10, y_10) | 0),
            }), createElement(SidebarMenuCollapsible_View, {
                p: p_1_11,
            })), link("Current", faCustomCurrentIcon, new Page(0, [new WeatherTypeModule_Parameter(2, [])])), (p_1_12 = ofList(map_1((value_35) => value_35, ofArray([["label", "Waves"], ["leftIcon", faWater], ["children", ofArray([link("Waves", undefined, new Page(0, [new WeatherTypeModule_Parameter(3, [])])), link("Wind Waves", undefined, new Page(0, [new WeatherTypeModule_Parameter(7, [])])), link("Primary Swell", undefined, new Page(0, [new WeatherTypeModule_Parameter(5, [])])), link("Secondary Swell", undefined, new Page(0, [new WeatherTypeModule_Parameter(6, [])]))])]])), {
                Compare: (x_11, y_11) => (comparePrimitives(x_11, y_11) | 0),
            }), createElement(SidebarMenuCollapsible_View, {
                p: p_1_12,
            })), link("Tide", faMoon, new Page(0, [new WeatherTypeModule_Parameter(4, [])])), link("Cloud cover", faCloud, new Page(0, [new WeatherTypeModule_Parameter(8, [])])), link("Air Temperature", faTemperatureHigh, new Page(0, [new WeatherTypeModule_Parameter(9, [])])), link("Precipitation", faCloudRain, new Page(0, [new WeatherTypeModule_Parameter(10, [])]))], (props_12 = {
                hideCloseButton: true,
            }, react.createElement(SidebarMenu, props_12, ...children)))]]])), timezone]]]))) : (PageModule_menuVisible(currentPage) ? singleton_1(toggleMenu) : empty_1()), delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["style", {
                overflowX: "hidden",
                width: 100 + "%",
            }], ["children", [HtmlHelper_createElement("div", ofArray([["className", "content"], ["children", singleton(HtmlHelper_createElement("div", ofArray([["className", "content-wrapper"], ["children", singleton(content)]])))]]))]]]))), delay(() => (PageModule_themeSwitcherVisible(currentPage) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", "theme-switcher"], ["onClick", (_arg_2) => {
                ThemeStorage_switchTheme();
            }], ["children", [HtmlHelper_createElement("div", ofArray([["className", "filler"], ["children", []]])), HtmlHelper_createElement("div", ofArray([["className", "knob"], ["children", singleton(SvgHelper_createSvgElement("svg", ofArray([["viewBox", `${0} ${0} ${512} ${512}`], svg_width(2 + "rem"), svg_height(2 + "rem"), ["children", singleton(SvgHelper_createSvgElement("path", empty()))]])))]]))]]]))) : empty_1())))));
        }));
    }))]]));
}

export function MainView($props) {
    let elements_1, matchValue_1, xs_4, tupledArg, queryString, children_8, children_5, xs_5, matchValue, p_1_1;
    const dispatch = $props.dispatch;
    const state = $props.state;
    const portWindSensorChange = (page, sensor, dateRange) => {
        const p = page(some(sensor))(dateRange);
        if (!equals(state.Page, p)) {
            Router_setUrlToPage(p);
            console.log(some(`Change sensor: ${sensor}`));
            dispatch(new Msg(0, [p]));
        }
    };
    const patternInput = useState(defaultArgWith(tryGetFromStorage(), getDefaultUserSettings));
    const timeZoneContext = new TimezoneContext(patternInput[0], (ctx) => {
        saveToStorage(ctx);
        patternInput[1](ctx);
    });
    const props_2 = createObj(ofArray([["hashMode", 2], ["onUrlChanged", (arg_1) => {
        dispatch(new Msg(0, [PageModule_parseFromUrlSegments(arg_1)]));
    }], (elements_1 = singleton(createElement(TimeZoneContext, {
        ctx: timeZoneContext,
        children: (matchValue_1 = state.Auth, (matchValue_1.tag === 1) ? ((xs_4 = [createElement("div", defaultOf(), "️⚠️ Insufficient permissions."), HtmlHelper_createElement("a", ofArray([["href", (tupledArg = PageModule_toUrlSegments(new Page(10, [])), (queryString = tupledArg[1], defaultArgWith(map((tupledArg_1) => RouterModule_encodeParts(append_1(tupledArg_1[0], singleton(tupledArg_1[1] + RouterModule_encodeQueryString(queryString))), 2), RouterModule_trySeparateLast(tupledArg[0])), () => RouterModule_encodeParts(singleton(RouterModule_encodeQueryString(queryString)), 2))))], ["onClick", (e) => {
            Router_goToUrl(e);
        }], ["children", singleton("Logout")]])), (children_8 = ofArray(["If you believe this is an error, please send the following information to ", HtmlHelper_createElement("a", ofArray([["children", singleton("weatherservice@stenaline.com")], ["href", "mailto:weatherservice@stenaline.com"]])), (children_5 = map_1((children_2) => createElement("pre", defaultOf(), children_2), msgHistoryLog()), createElement("div", defaultOf_1(), ...children_5))]), createElement("details", defaultOf_1(), ...children_8))], createElement(Fragment, defaultOf_2(), ...xs_4))) : ((matchValue_1.tag === 2) ? ((xs_5 = [(start(onAnalyticsAPI(state.ClientSessionId, (x) => x.TrackPageView(`${state.Page}`, window.location.href, state.ClientSessionId, navigator.platform + ' ' + navigator.oscpu + ' ' + navigator.userAgent, `${state.Auth}`))), (matchValue = state.Page, (matchValue.tag === 12) ? defaultOf_3() : ((matchValue.tag === 10) ? defaultOf_3() : ((matchValue.tag === 11) ? defaultOf_3() : ((matchValue.tag === 0) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(ModelsView, {
            p: matchValue.fields[0],
        })) : ((matchValue.tag === 1) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(VesselsView, null)) : ((matchValue.tag === 2) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(SessionDetailsView, {
            voyageId: matchValue.fields[0],
        })) : ((matchValue.tag === 3) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(SessionReportView, {
            sessionId: matchValue.fields[0],
        })) : ((matchValue.tag === 4) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(DashboardView, null)) : ((matchValue.tag === 8) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindStatusView, {
            clientSessionId: state.ClientSessionId,
        })) : ((matchValue.tag === 9) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindOutageReportView, {
            sensor: unwrap(matchValue.fields[0]),
            clientSessionId: state.ClientSessionId,
        })) : ((matchValue.tag === 5) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindDashboardView, {
            initStateChange: (x_1) => x_1,
            viewConfig: ViewConfigModule_Default,
            reservedWidth: state.ShowMenu ? 250 : Const_menuToggleOpenSize,
            sensorId: unwrap(matchValue.fields[0]),
            dateRange: new DateTimeRange(undefined, undefined),
            sensorReportChangeToMainView: uncurry2(curry3(portWindSensorChange)((s) => ((_arg) => (new Page(5, [s]))))),
            clientSessionId: state.ClientSessionId,
            page: state.Page,
        })) : ((matchValue.tag === 6) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindDashboardView, {
            initStateChange: (state_1) => (new State_1(state_1.Sensors, state_1.SelectedSensor, state_1.DateTimeRange, state_1.HiddenWeatherValues, state_1.HiddenSensors, state_1.Weather, state_1.WeatherHistory, false, state_1.MainView, state_1.ClientSessionId, state_1.ThresholdLines, state_1.IsRefreshing, state_1.PollGeneration)),
            viewConfig: ViewConfigModule_Simple,
            reservedWidth: 0,
            sensorId: unwrap(matchValue.fields[0]),
            dateRange: new DateTimeRange(undefined, undefined),
            sensorReportChangeToMainView: uncurry2(curry3(portWindSensorChange)((s_1) => ((_arg_1) => (new Page(6, [s_1]))))),
            clientSessionId: state.ClientSessionId,
            page: state.Page,
        })) : ((matchValue.tag === 7) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindDashboardView, {
            initStateChange: (x_2) => x_2,
            viewConfig: ViewConfigModule_Report,
            reservedWidth: state.ShowMenu ? 250 : Const_menuToggleOpenSize,
            sensorId: unwrap(matchValue.fields[0]),
            dateRange: matchValue.fields[1],
            sensorReportChangeToMainView: uncurry2(curry3(portWindSensorChange)((s_2) => ((r) => (new Page(7, [s_2, r]))))),
            clientSessionId: state.ClientSessionId,
            page: state.Page,
        })) : defaultOf_3()))))))))))))))], createElement(Fragment, defaultOf_2(), ...xs_5))) : ((matchValue_1.tag === 3) ? ((xs_5 = [(start(onAnalyticsAPI(state.ClientSessionId, (x) => x.TrackPageView(`${state.Page}`, window.location.href, state.ClientSessionId, navigator.platform + ' ' + navigator.oscpu + ' ' + navigator.userAgent, `${state.Auth}`))), (matchValue = state.Page, (matchValue.tag === 12) ? defaultOf_3() : ((matchValue.tag === 10) ? defaultOf_3() : ((matchValue.tag === 11) ? defaultOf_3() : ((matchValue.tag === 0) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(ModelsView, {
            p: matchValue.fields[0],
        })) : ((matchValue.tag === 1) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(VesselsView, null)) : ((matchValue.tag === 2) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(SessionDetailsView, {
            voyageId: matchValue.fields[0],
        })) : ((matchValue.tag === 3) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(SessionReportView, {
            sessionId: matchValue.fields[0],
        })) : ((matchValue.tag === 4) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(DashboardView, null)) : ((matchValue.tag === 8) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindStatusView, {
            clientSessionId: state.ClientSessionId,
        })) : ((matchValue.tag === 9) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindOutageReportView, {
            sensor: unwrap(matchValue.fields[0]),
            clientSessionId: state.ClientSessionId,
        })) : ((matchValue.tag === 5) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindDashboardView, {
            initStateChange: (x_1) => x_1,
            viewConfig: ViewConfigModule_Default,
            reservedWidth: state.ShowMenu ? 250 : Const_menuToggleOpenSize,
            sensorId: unwrap(matchValue.fields[0]),
            dateRange: new DateTimeRange(undefined, undefined),
            sensorReportChangeToMainView: uncurry2(curry3(portWindSensorChange)((s) => ((_arg) => (new Page(5, [s]))))),
            clientSessionId: state.ClientSessionId,
            page: state.Page,
        })) : ((matchValue.tag === 6) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindDashboardView, {
            initStateChange: (state_1) => (new State_1(state_1.Sensors, state_1.SelectedSensor, state_1.DateTimeRange, state_1.HiddenWeatherValues, state_1.HiddenSensors, state_1.Weather, state_1.WeatherHistory, false, state_1.MainView, state_1.ClientSessionId, state_1.ThresholdLines, state_1.IsRefreshing, state_1.PollGeneration)),
            viewConfig: ViewConfigModule_Simple,
            reservedWidth: 0,
            sensorId: unwrap(matchValue.fields[0]),
            dateRange: new DateTimeRange(undefined, undefined),
            sensorReportChangeToMainView: uncurry2(curry3(portWindSensorChange)((s_1) => ((_arg_1) => (new Page(6, [s_1]))))),
            clientSessionId: state.ClientSessionId,
            page: state.Page,
        })) : ((matchValue.tag === 7) ? inLayout(dispatch, state.ShowMenu, state.Page, createElement(PortWindDashboardView, {
            initStateChange: (x_2) => x_2,
            viewConfig: ViewConfigModule_Report,
            reservedWidth: state.ShowMenu ? 250 : Const_menuToggleOpenSize,
            sensorId: unwrap(matchValue.fields[0]),
            dateRange: matchValue.fields[1],
            sensorReportChangeToMainView: uncurry2(curry3(portWindSensorChange)((s_2) => ((r) => (new Page(7, [s_2, r]))))),
            clientSessionId: state.ClientSessionId,
            page: state.Page,
        })) : defaultOf_3()))))))))))))))], createElement(Fragment, defaultOf_2(), ...xs_5))) : ((p_1_1 = ofList(map_1((value) => value, singleton(["text", "Loading ..."])), {
            Compare: (x_3, y) => (comparePrimitives(x_3, y) | 0),
        }), createElement(LoadingScreenModule_View, {
            p: p_1_1,
        })))))),
    })), ["application", createElement(Fragment, defaultOf_2(), ...elements_1)])]));
    if (!((props_2 !== null && typeof props_2 === "object" && !Array.isArray(props_2)))) {
        console.error(some("React.memoRender: props must be an object."));
    }
    return createElement(RouterModule_router, Interop_setKeyOnObj(undefined, props_2));
}

